import { Capacitor } from '@capacitor/core';
import { Navigate, createBrowserRouter, createHashRouter } from 'react-router-dom';
import { AppShell } from '../layouts/AppShell';
import { ImportantDateFormPage } from '../pages/ImportantDateFormPage';
import { PersonDetailPage } from '../pages/PersonDetailPage';
import { PersonFormPage } from '../pages/PersonFormPage';
import DayKeeperPreview from '../pages/CanonicalDesignPage';

const createRouter = Capacitor.isNativePlatform() ? createHashRouter : createBrowserRouter;

export const router = createRouter([
  { path: '/', element: <DayKeeperPreview initialActive="home" /> },
  { path: '/add', element: <DayKeeperPreview initialAddingSubject /> },
  { path: '/people', element: <DayKeeperPreview initialActive="list" /> },
  { path: '/calendar', element: <DayKeeperPreview initialActive="calendar" /> },
  { path: '/settings', element: <DayKeeperPreview initialActive="settings" /> },
  {
    element: <AppShell />,
    children: [
      { path: '/people/new', element: <PersonFormPage mode="create" /> },
      { path: '/people/:id', element: <PersonDetailPage /> },
      { path: '/people/:id/edit', element: <PersonFormPage mode="edit" /> },
      { path: '/people/:personId/dates/new', element: <ImportantDateFormPage mode="create" /> },
      { path: '/important-dates/:id/edit', element: <ImportantDateFormPage mode="edit" /> },
      { path: '/events', element: <Navigate to="/people" replace /> },
      { path: '/events/new', element: <Navigate to="/add" replace /> },
      { path: '/events/:id', element: <Navigate to="/people" replace /> },
      { path: '/events/:id/edit', element: <Navigate to="/people" replace /> },
      { path: '/birthdays', element: <Navigate to="/people" replace /> },
      { path: '/birthdays/new', element: <Navigate to="/add" replace /> },
      { path: '/birthdays/:id', element: <Navigate to="/people" replace /> },
      { path: '/birthdays/:id/edit', element: <Navigate to="/people" replace /> },
    ],
  },
]);
